import { CALL_API } from "admin/middlewares/api";

export const USER_INVOICES_LIST_GET_REQUEST = "USER_INVOICES_LIST_GET_REQUEST";
export const USER_INVOICES_LIST_GET_SUCCESS = "USER_INVOICES_LIST_GET_SUCCESS";
export const USER_INVOICES_LIST_GET_ERROR = "USER_INVOICES_LIST_GET_ERROR";

export function get_invoices_by_account(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        USER_INVOICES_LIST_GET_REQUEST,
        USER_INVOICES_LIST_GET_SUCCESS,
        USER_INVOICES_LIST_GET_ERROR,
      ],
    },
  };
}

export const USER_INVOICE_LIST_CHANGE_PAGE = "USER_INVOICE_LIST_CHANGE_PAGE";

export function change_invoice_list_page(page) {
  return {
    type: USER_INVOICE_LIST_CHANGE_PAGE,
    page,
  };
}

export const USER_INVOICE_LIST_CHANGE_FILTER =
  "USER_INVOICE_LIST_CHANGE_FILTER";

export function change_invoice_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: USER_INVOICE_LIST_CHANGE_FILTER,
    filter,
  };
}

export const USER_INVOICE_ADD_ROW_REQUEST = "USER_INVOICE_ADD_ROW_REQUEST";
export const USER_INVOICE_ADD_ROW_SUCCESS = "USER_INVOICE_ADD_ROW_SUCCESS";
export const USER_INVOICE_ADD_ROW_ERROR = "USER_INVOICE_ADD_ROW_ERROR";

export function add_invoice_row(invoiceRow) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/addrow",
      method: "POST",
      data: { InvoiceRow: invoiceRow },
      authenticatedRequest: true,
      types: [
        USER_INVOICE_ADD_ROW_REQUEST,
        USER_INVOICE_ADD_ROW_SUCCESS,
        USER_INVOICE_ADD_ROW_ERROR,
      ],
    },
  };
}

export const USER_INVOICE_REMOVE_ROW_REQUEST =
  "USER_INVOICE_REMOVE_ROW_REQUEST";
export const USER_INVOICE_REMOVE_ROW_SUCCESS =
  "USER_INVOICE_REMOVE_ROW_SUCCESS";
export const USER_INVOICE_REMOVE_ROW_ERROR = "USER_INVOICE_REMOVE_ROW_ERROR";

export function remove_invoice_row(loanId, invoiceId, rowId, draft) {
  let draftUrl = draft == true ? "/drafts" : "";
  let data =
    draft == true
      ? { LoanId: loanId, DraftId: invoiceId, RowId: rowId }
      : { LoanId: loanId, InvoiceId: invoiceId, RowIds: [rowId] };

  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices" + draftUrl + "/removerow",
      method: "POST",
      data,
      authenticatedRequest: true,
      types: [
        USER_INVOICE_REMOVE_ROW_REQUEST,
        USER_INVOICE_REMOVE_ROW_SUCCESS,
        USER_INVOICE_REMOVE_ROW_ERROR,
      ],
    },
  };
}

export const USER_INVOICE_REGISTER_PAYMENT_REQUEST =
  "USER_INVOICE_REGISTER_PAYMENT_REQUEST";
export const USER_INVOICE_REGISTER_PAYMENT_SUCCESS =
  "USER_INVOICE_REGISTER_PAYMENT_SUCCESS";
export const USER_INVOICE_REGISTER_PAYMENT_ERROR =
  "USER_INVOICE_REGISTER_PAYMENT_ERROR";

export function register_invoice_payment(
  loanId,
  customerRefCode,
  staffRefCode,
  amount,
  receiveDate,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices/registerpayment",
      method: "POST",
      data: {
        LoanId: loanId,
        CustomerRefCode: customerRefCode,
        StaffCorrectedRefCode: staffRefCode,
        Amount: amount,
        BankReceiveDate: receiveDate,
      },
      authenticatedRequest: true,
      types: [
        USER_INVOICE_REGISTER_PAYMENT_REQUEST,
        USER_INVOICE_REGISTER_PAYMENT_SUCCESS,
        USER_INVOICE_REGISTER_PAYMENT_ERROR,
      ],
    },
  };
}

export const USER_INVOICE_CANCEL_PAYMENT_REQUEST =
  "USER_INVOICE_CANCEL_PAYMENT_REQUEST";
export const USER_INVOICE_CANCEL_PAYMENT_SUCCESS =
  "USER_INVOICE_CANCEL_PAYMENT_SUCCESS";
export const USER_INVOICE_CANCEL_PAYMENT_ERROR =
  "USER_INVOICE_CANCEL_PAYMENT_ERROR";

export function cancel_invoice_payment(paymentId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/cancelpayment",
      method: "POST",
      data: { PaymentId: paymentId },
      authenticatedRequest: true,
      types: [
        USER_INVOICE_CANCEL_PAYMENT_REQUEST,
        USER_INVOICE_CANCEL_PAYMENT_SUCCESS,
        USER_INVOICE_CANCEL_PAYMENT_ERROR,
      ],
    },
  };
}

// Short term invoices

export const USER_ST_INVOICES_LIST_GET_REQUEST =
  "USER_ST_INVOICES_LIST_GET_REQUEST";
export const USER_ST_INVOICES_LIST_GET_SUCCESS =
  "USER_ST_INVOICES_LIST_GET_SUCCESS";
export const USER_ST_INVOICES_LIST_GET_ERROR =
  "USER_ST_INVOICES_LIST_GET_ERROR";

export function get_st_invoices_by_account(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices/shortterm?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        USER_ST_INVOICES_LIST_GET_REQUEST,
        USER_ST_INVOICES_LIST_GET_SUCCESS,
        USER_ST_INVOICES_LIST_GET_ERROR,
      ],
    },
  };
}

export const USER_ST_INVOICE_LIST_CHANGE_PAGE =
  "USER_ST_INVOICE_LIST_CHANGE_PAGE";

export function change_st_invoice_list_page(page) {
  return {
    type: USER_ST_INVOICE_LIST_CHANGE_PAGE,
    page,
  };
}

export const USER_ST_INVOICE_LIST_CHANGE_FILTER =
  "USER_ST_INVOICE_LIST_CHANGE_FILTER";

export function change_st_invoice_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: USER_ST_INVOICE_LIST_CHANGE_FILTER,
    filter,
  };
}
